export default {
  namespaced: true,

  state: {
    general: {
      housingType: null,
      housingTypeOther: '',
      facilities: [],
      rating: 0,
      comment: '',
    },

    kitchenEquipment: [],
    kitchenEquipmentOther: '',

    otherEquipment: [],
    otherEquipmentOther: '',

    owner: {
      name: '',
      mobile: '',
      email: '',
      deposit: '',
      rent: '',
      costs: '',
    },

    address: {
      street: '',
      postalCode: '',
      city: '',
      country: '',
    },
  },

  mutations: {
    SET_GENERAL(state, data) {
      state.general[data.key] = data.value;
    },

    SET_KITCHEN_EQUIPMENT(state, data) {
      state.kitchenEquipment = data;
    },

    SET_KITCHEN_EQUIPMENT_OTHER(state, data) {
      state.kitchenEquipmentOther = data;
    },

    SET_OTHER_EQUIPMENT(state, data) {
      state.otherEquipment = data;
    },

    SET_OTHER_EQUIPMENT_OTHER(state, data) {
      state.otherEquipmentOther = data;
    },

    SET_OWNER(state, data) {
      state.owner[data.key] = data.value;
    },

    SET_ADDRESS(state, data) {
      state.address[data.key] = data.value;
    },
  },
};
